import "./styles.less";

import { Button } from "antd";
import { WhatsAppOutlined } from "@ant-design/icons";

const WPP_NUMBER = "573160101107";
const WPP_MESSAGE =
	"Hola 👋 Quiero publicar mis inmuebles en Fincaraíz. ¿Qué planes tienen para inmobiliarias y agentes?";
// api.whatsapp.com y no wa.me: la redirección de wa.me rompe los emojis del texto
const WPP_URL = `https://api.whatsapp.com/send?phone=${WPP_NUMBER}&text=${encodeURIComponent(WPP_MESSAGE)}`;

export const B2BBanner = () => {
	return (
		<div className="b2b-banner__container">
			<div className="b2b-banner">
				<div className="b2b-banner__text">
					<h3 className="b2b-banner__title">¿Eres inmobiliaria o constructora?</h3>
					<p className="b2b-banner__subtitle">Publica tus inmuebles en Fincaraiz con un plan a tu medida</p>
				</div>
				<Button
					className="b2b-banner__button"
					icon={<WhatsAppOutlined />}
					href={WPP_URL}
					target="_blank"
					rel="noopener noreferrer"
				>
					Quiero publicar
				</Button>
			</div>
		</div>
	);
};
